import { Fragment } from "react";
import { opKey } from "@/app/groupPerformance";
import { PB_STATE, type PrimaryBackupList } from "@/app/health";
import { Pill, Tooltip } from "@/ui";

/** 通道组合列表行内的主备标记（docs/04“通道组合详情页面”一节，决策 D92）：只标切走与验证中的运营商数，悬停或聚焦看是哪些运营商（可聚焦的 Tooltip，键盘与读屏也拿得到）。
 * 冷却中的主用照常走主通道不标；快照过期时路由不看这些状态（docs/10 第 9 节），也不标。 */
export function PrimaryBackupMarks({ pb, groupID }: { pb?: PrimaryBackupList; groupID: number }) {
  if (!pb?.built_at) return null;
  const rows = pb.items.filter((r) => r.group_id === groupID);
  return (
    <>
      {(["switched", "verifying"] as const).map((state) => {
        const ops = rows.filter((r) => r.state === state).map(opKey);
        return ops.length > 0 && <Fragment key={state}> <Tooltip content={ops.join("、")}><span tabIndex={0}><Pill tone={PB_STATE[state].tone}>{ops.length} 个运营商{PB_STATE[state].label}</Pill></span></Tooltip></Fragment>;
      })}
    </>
  );
}
